import React from 'react';
import ReactDOM from 'react-dom';
import { KatSpinner } from '@amzn/katal-react';

import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import { StencilProvider } from '@amzn/stencil-react-components/context';
import { GlobalContextProvider } from './context/GlobalContext';
import { UserDataContextProvider } from './context/UserDataContext';
import { AutoLogoutBoundary } from './components/AutoLogoutBoundary';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

import './index.scss';

ReactDOM.render(
  <React.StrictMode>
    <AppInitWrapper>
      <React.Suspense fallback={<KatSpinner size='large' />}>
        <StencilProvider>
          <I18nextProvider i18n={i18n}>
            <GlobalContextProvider>
              <UserDataContextProvider>
                <AutoLogoutBoundary>
                  <App />
                </AutoLogoutBoundary>
              </UserDataContextProvider>
            </GlobalContextProvider>
          </I18nextProvider>
        </StencilProvider>
      </React.Suspense>
    </AppInitWrapper>
  </React.StrictMode>,
  document.getElementById('root')
);
